import { render, staticRenderFns } from "./DriversLicense.vue?vue&type=template&id=0782f5d0&"
import script from "./DriversLicense.vue?vue&type=script&lang=js&"
export * from "./DriversLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports